module.exports = __webpack_public_path__ + "img/hero-fire-01.68385d5e.png";